import Logo from './images/logo.png';
import Banner_1 from './images/banner_1.jpg';
import Banner_2 from './images/banner_2.jpg';
import payOption1 from './images/pay1.png';
import payOption2 from './images/pay2.png';
import payOption3 from './images/pay3.png';
import payOption4 from './images/pay4.png';
import icon1 from './images/icons/icon1.png';
import icon2 from './images/icons/icon2.png';
import icon3 from './images/icons/icon3.png';
import polygonBG from './images/polygon-bg.png';
import process1 from './images/image1.jpg';
import process2 from './images/image2.jpg';
import prod1 from './images/prod1.png';
import prod2 from './images/prod2.png';
import prod3 from './images/prod3.png';
import technology1 from './images/icons/android.jpg';
import technology2 from './images/icons/angular.jpg';
import technology3 from './images/icons/html.jpg';
import technology4 from './images/icons/ios.jpg';
import technology5 from './images/icons/php.jpg';
import technology6 from './images/icons/react.jpg';
import user1 from './images/user1.jpg';
import award1 from './images/award1.png';
import Layer1 from './images/technologies/Layer1.png';
import Layer2 from './images/technologies/Layer2.png';
import Layer3 from './images/technologies/Layer3.png';
import Layer4 from './images/technologies/Layer4.png';
import Layer5 from './images/technologies/Layer5.png';
import Layer6 from './images/technologies/Layer6.png';
import Layer7 from './images/technologies/Layer7.png';
import Layer8 from './images/technologies/Layer8.png';
import Layer9 from './images/technologies/Layer9.png';
import Layer10 from './images/technologies/Layer10.png';
import Layer11 from './images/technologies/Layer11.png';
import Layer12 from './images/technologies/Layer12.png';
import Layer13 from './images/technologies/Layer13.png';
import Layer14 from './images/technologies/Layer14.png';
import Layer15 from './images/technologies/Layer15.png';
import Layer16 from './images/technologies/Layer16.png';
import Layer17 from './images/technologies/Layer17.png';
import Layer18 from './images/technologies/Layer18.png';
import Layer19 from './images/technologies/Layer19.png';
import Layer20 from './images/technologies/Layer20.png';
import Layer21 from './images/technologies/Layer21.png';
import Layer22 from './images/technologies/Layer22.png';
import Layer23 from './images/technologies/Layer23.png';
import Layer24 from './images/technologies/Layer24.png';
import Layer25 from './images/technologies/Layer25.png';
import Layer26 from './images/technologies/Layer26.png';
import Layer27 from './images/technologies/Layer27.png';
import Layer28 from './images/technologies/Layer28.png';
import Layer29 from './images/technologies/Layer29.png';
import Layer30 from './images/technologies/Layer30.png';
import Layer31 from './images/technologies/Layer31.png';
import Layer32 from './images/technologies/Layer32.png';
import Layer33 from './images/technologies/Layer33.png';
import Layer34 from './images/technologies/Layer34.png';
import Layer35 from './images/technologies/Layer35.png';
import parthership from './images/parthership.png';
import get_in_touch from './images/Layer-1.jpg';
import rafiki from './images/rafiki.png';
import noimage from './images/noimage.png';



export const images = {
    Logo, Banner_1, Banner_2, payOption1, payOption2, payOption3, payOption4, icon1, icon2, icon3, polygonBG, process1, process2, prod1, prod2, prod3, technology1, technology2, technology3, technology4, technology5, technology6, user1, award1,Layer1, 
    Layer2,
    Layer3,
    Layer4,
    Layer5,
    Layer6,
    Layer7,
    Layer8,
    Layer9,
    Layer10,
    Layer11,
    Layer12,
    Layer13,
    Layer14,
    Layer15,
    Layer16,
    Layer17,
    Layer18,
    Layer19,
    Layer20,
    Layer21,
    Layer22,
    Layer23,
    Layer24,
    Layer25,
    Layer26,
    Layer27,
    Layer28,
    Layer29,
    Layer30,
    Layer31,
    Layer32,
    Layer33,
    Layer34,
    Layer35,
    parthership,
    get_in_touch,
    rafiki,
    noimage,
}